import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, unref as _unref, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-58b95a6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "col-12 col-lg-8"
}
const _hoisted_2 = {
  key: 1,
  class: "col-1 d-flex align-items-center justify-content-center"
}
const _hoisted_3 = {
  key: 2,
  class: "col-11 col-lg-7"
}
const _hoisted_4 = {
  key: 3,
  class: "col-1 d-flex flex-column align-items-center justify-content-center p-4 edit-panel"
}
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "mt-2"
}

import { ref, onMounted } from "vue";
    import {
        MDBIcon,
        MDBSpinner,
    } from "mdb-vue-ui-kit";
    import FeedArticle from "@/components/FeedArticle.vue";
    import ReplyArticle from "@/components/ReplyArticle.vue";
    import { CompactSign } from "jose-browser-runtime";

    import { addArticleToList, getKeyPair, getListGroup } from '@/functions/store';
    import { extractRef } from '@/functions/utility';
    import axios from 'axios';

    
export default /*#__PURE__*/_defineComponent({
  props: {
        thread: {
            type: Array,
            required: true
        },
        editMode: {
            type: Boolean,
            required: false
        },
        addList: {
            type: String,
            required: false
        },
        feedUrl: {
            type: String,
            required: true
        },
    },
  setup(__props) {

const props = __props

    const encoder = new TextEncoder();

    // define props
    

    const threadItems = ref(props.thread);
    const addingArticle = ref(-1);
    const deletingArticle = ref(-1);

    /**
    * Add Article to List at Desired Position
    *
    * @param article Article to add to to List
    * @param i Desired Index
    */
    async function addArticle(article: any, i: number) {
        addingArticle.value = i;
        const articleObj = JSON.parse(JSON.stringify(article));

        const list = props.addList;
        if (list?.includes('L | ')) {
            const listName = list.replace(/[LG] \| /, '');
            await addArticleToList(listName, articleObj.feedCopy);
        }
        if (list?.includes('G | ')) {
            const groupName = list.replace(/[LG] \| /, '');

            const listGroup = await getListGroup(groupName);
            if (listGroup.length == 0) {
                addingArticle.value = -1;
                return false;
            }
            for (let i = 0; i < listGroup[0].lists.length; i++) {
                const l = listGroup[0].lists[i];

                await addArticleToList(l.name, articleObj.feedCopy);
            }
        }

        addingArticle.value = -1
    }

    let feedEditKeyPair: any;
    const feedEditKeyName = localStorage.getItem('feedEditKey');


    /**
    * Delete Article from List at Desired Location
    *
    * @param article Article to Delete
    * @param i Desired Index
    */
    async function deleteArticle(article: any, i: number) {
        deletingArticle.value = i;
        const articleObj = JSON.parse(JSON.stringify(article));

        // assemble url
        const hash = articleObj.infoHash;
        const urlObj = new URL(props.feedUrl);
        const url = 'https://' + urlObj.hostname + '/api/article/' + hash;

        try {
            // create JWS of article
            const JWS = await new CompactSign(encoder.encode(JSON.stringify(articleObj)))
                .setProtectedHeader({
                    alg: 'ES384',
                    kid: feedEditKeyPair.kid
                })
                .sign(feedEditKeyPair.private);

            const resp = await axios.delete(url, {
                data: {
                    token: JWS
                },
            });

            console.log(resp);

            // remove item from thread
            let newItems = extractRef(threadItems);
            newItems.splice(i, 1);
            threadItems.value = newItems;
        } catch (error) {
            console.error(error);

            if (error instanceof Error) {
                alert(error.message);
            }
        }

        deletingArticle.value = -1
    }

    onMounted(async () => {
        if (feedEditKeyName != null) {
            feedEditKeyPair = await getKeyPair(feedEditKeyName);
        }
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(threadItems.value, (article, index) => {
    return (_openBlock(), _createElementBlock("div", {
      class: "row justify-content-center my-3",
      key: 'article-' + article.infoHash
    }, [
      (index == 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(FeedArticle, { article: article }, null, 8, ["article"])
          ]))
        : _createCommentVNode("", true),
      (index != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_unref(MDBIcon), {
              icon: "caret-right",
              iconStyle: "fas",
              size: "2x"
            })
          ]))
        : _createCommentVNode("", true),
      (index != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(ReplyArticle, { article: article }, null, 8, ["article"])
          ]))
        : _createCommentVNode("", true),
      (__props.editMode)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (__props.addList.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (addingArticle.value !== index)
                    ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                        key: 0,
                        icon: "plus",
                        iconStyle: "fas",
                        size: "2x",
                        title: "Add to list",
                        onClick: ($event: any) => (addArticle(article, index))
                      }, null, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_unref(MDBSpinner), { key: 1 }))
                ]))
              : _createCommentVNode("", true),
            (_unref(feedEditKeyName) != null)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (deletingArticle.value !== index)
                    ? (_openBlock(), _createBlock(_unref(MDBIcon), {
                        key: 0,
                        icon: "trash",
                        iconStyle: "fas",
                        size: "2x",
                        title: "Delete from Feed",
                        onClick: ($event: any) => (deleteArticle(article, index))
                      }, null, 8, ["onClick"]))
                    : (_openBlock(), _createBlock(_unref(MDBSpinner), { key: 1 }))
                ]))
              : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]))
  }), 128))
}
}

})